// Affiliate token cookie management helpers

// Helper to determine if we're in production
const isProduction = process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'prod';

export const getAffiliateToken = () => {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'affiliateToken') {
      return value;
    }
  }
  return null;
};

export const setAffiliateToken = (token: string) => {
  const date = new Date();
  date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 days
  const expires = `expires=${date.toUTCString()}`;
  const secure = isProduction ? ';Secure' : '';
  document.cookie = `affiliateToken=${token};${expires};path=/;SameSite=Lax${secure}`;
};

export const removeAffiliateToken = () => {
  const secure = isProduction ? ';Secure' : '';
  document.cookie = `affiliateToken=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Lax${secure}`;
};